import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-marquee">
                <div className="marquee-content">
                    <span>Precision CNC, VMC, drilling, milling, and cutting services delivering high-quality industrial components for manufacturing industries.</span>
                    <span>Precision CNC, VMC, drilling, milling, and cutting services delivering high-quality industrial components for manufacturing industries.</span>
                </div>
            </div>

            <div className="container footer-main">
                <div className="footer-grid">
                    <div className="footer-col">
                        <h4>Contact Info</h4>
                        <p className="address">
                            No.6, Vivekanandha Street,<br />
                            2nd Cross Street,<br />
                            Balaji Nagar, Ambattur West,<br />
                            Chennai - 600 053
                        </p>
                        <p className="contact-item">
                            Phone: +91 93822 68887, +91 98845 31477
                        </p>
                        <p className="contact-item">
                            sakthivelengg87@gmail.com
                        </p>
                    </div>

                    <div className="footer-col">
                        <h4>Our Services</h4>
                        <ul>
                            <li><a href="/services">CNC Machining</a></li>
                            <li><a href="/services">VMC Machining</a></li>
                            <li><a href="/services">Drilling Operations</a></li>
                            <li><a href="/services">Milling Services</a></li>
                            <li><a href="/services">Metal Cutting</a></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="#home">Home</a></li>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#capabilities">Machines</a></li>
                            <li><a href="#gallery">Components</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container bottom-container">
                    <p>&copy; 2026 Sakthivel Engineering. All Rights Reserved.</p>
                    <div className="bottom-links">
                        <a href="#privacy">Privacy Policy</a>
                        <a href="#terms">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
